const menu = "_menu_1x5h1_17";
const title = "_title_1x5h1_83";
const styles = {
  menu,
  "slide-in": "_slide-in_1x5h1_1",
  "slide-out": "_slide-out_1x5h1_1",
  "fade-in": "_fade-in_1x5h1_1",
  "fade-out": "_fade-out_1x5h1_1",
  title
};
export {
  styles as default,
  menu,
  title
};
//# sourceMappingURL=FloatingMenu.module.css.js.map
